export const photoCaptureUpdateContextReducer = (state, action) => {
    // Using type assertion to tell TypeScript what the payload shape is
    const payload = action.payload;
    return Object.assign(Object.assign({}, state), { isContextUpdated: true, 
        // If you need to store the selected shop info in state:
        isShopUpdatedByUser: payload.isShopUpdatedByUser || state.isShopUpdatedByUser || false });
};
//# sourceMappingURL=photoCaptureUpdateContextReducer.js.map